
import { debounce } from 'lodash'
import { Vue, Component, Prop } from 'vue-property-decorator'
import PopupRadio from '@/components/popup-radio.vue'
import PhoneInput from '@/components/common/phone-input.vue'
import { checkVatValid } from '@ad/account-info-sdk'
import BytedIconHelp from '@byte-design/vue-icons/icons/Help'
import { State } from 'vuex-class'
import { trackEvent } from '@/tea-tracker'
import { TYPE, FIELD, COMPONENT } from '@/const/qualification'
import { validatorsFun } from '@/utils/validationUtil'

@Component({
  name: 'QualificationItem',
  components: {
    PopupRadio,
    BytedIconHelp,
    PhoneInput,
  },
})
export default class QualificationItem extends Vue {
  @State(state => state?.account?.accountInfo?.country) country: string
  @State('qualConfig', { namespace: 'qualification' }) qualConfig: any
  @State('commonI18nTrans', { namespace: 'qualification' }) commonI18nTrans: any
  @Prop({
    type: Object,
    default: () => ({
      field: '',
      type: '',
      name: '',
      label: '',
      component: '',
      placeholder: '',
      extraTips: '',
      template: undefined,
      validators: [],
      options: [],
      hidden: false,
      children: [],
      disabled: false,
    }),
  })
  config: Record<string, any>
  @Prop({
    type: Object,
    default: () => ({
      address_detail: '',
      state: '',
      city: '',
      county: '',
      post_code: '',
      payment: '',
      tax_type: -1,
      tax_value: {},
    }),
  })
  formData: Record<string, any>
  @Prop({ type: Boolean, default: false }) border: boolean
  @Prop({ type: Boolean, default: false }) moduleError: boolean
  @Prop({ default: () => ({}), type: Object }) showRules: object
  @Prop({ type: Number, default: null }) currentOrder: number

  refs: {
    phoneInputRef: {
      validateTelephone: () => Promise<boolean>;
    };
  }

  show = false
  message = ''
  showExtraTips = false
  showOuterTip = false
  debounceValidator = debounce(() => this.validator(), 500)

  get optional() {
    const { commonI18nTrans = {} } = this.qualConfig || {}
    return commonI18nTrans?.optional
  }
  get chosen() {
    if (this.config.field === FIELD.TAX_VALUE) {
      return this.formData?.tax_value?.[this.config?.name] || ''
    }

    return this.formData?.[this.config?.name] || ''
  }
  get filter() {
    return ['state', 'county', 'city'].includes(this.config?.name)
  }
  get cellError() {
    return this.config?.type === TYPE.CELL && this.message
  }
  get linkUrl() {
    return this.config?.extraTips?.url?.value
  }
  get linkText() {
    return this.config?.extraTips?.url?.i18n
  }
  get isAnInputComponent() {
    return (
      this.config?.component === COMPONENT.INPUT &&
      this.config?.type === TYPE.CELL
    )
  }
  get getBillingInfoBackFields() {
    return this.config?.hidden || !this.config?.name ? '' : this.config?.name
  }
  get defaultInputValue() {
    if (!this.isAnInputComponent) {
      return ''
    }
    return this.config?.field === FIELD.TAX_VALUE
      ? this.formData?.[FIELD.TAX_VALUE]?.[this.config?.name]
      : this.formData?.[this.config?.name]
  }
  get getPlaceholder() {
    const { type, children, validators, placeholder, required, optional } = this.config
    let str = placeholder
    if (type === TYPE.CELL && !optional) {
      str =
        validators?.some(i => i?.required) || required
          ? placeholder
          : this.optional
    } else if (type === TYPE.MODULE) {
      const showCell = children?.filter(i => !i?.hidden)
      str = showCell?.some(c => c?.validators?.some(i => i?.required))
        ? placeholder
        : this.optional
    }
    return str
  }
  get isAnPrueInputComponent(): boolean {
    return this.config.component === COMPONENT.INPUT
  }
  get isPhoneInputComponent(): boolean {
    return this.config.component === COMPONENT.PHONE_INPUT_COMPONENT
  }
  get getValueStr(): string {
    const { config, formData } = this
    let { type, name, options, children, component, field } = config
    if (type === TYPE.MODULE) {
      let valArr = []
      children.map((item: any) => {
        let val = formData?.[item.name]
        if (item.field === FIELD.TAX_VALUE) {
          val = formData?.[FIELD.TAX_VALUE]?.[item.name]
        }
        if (item.field === FIELD.TELEPHONE) {
          val = formData?.telephone?.phonenumber
        }
        if (!val || val === -1) {
          return
        }
        if (
          [COMPONENT.INPUT, COMPONENT.PHONE_INPUT_COMPONENT].includes(
            item.component,
          )
        ) {
          return valArr.push(val)
        }
        const obj = item.options.find(i => i.value === val)
        return valArr.push(obj?.label)
      })
      return valArr.length ? valArr.join(' | ') : ''
    } else {
      const val = formData?.[name]
      if (field === FIELD.TAX_VALUE && component === COMPONENT.PICKER) {
        return options.find(i => i.value === formData?.tax_value?.[name])?.label
      }
      if (!val || val === -1) {
        return ''
      }
      if (component === COMPONENT.INPUT) {
        return val
      }
      const obj = options.find(i => i.value === val)
      return obj?.label
    }
  }
  get isLink(): boolean {
    return (
      this.config?.children?.length > 1 ||
      this.config?.component !== COMPONENT.INPUT
    )
  }
  get inputMaxLength(): number {
    if (this.config?.name === 'post_code') {
      return 40
    }
    return undefined
  }

  created() {}
  flagPushTrack() {
    trackEvent('adp_waplite_click', {
      order: this.currentOrder,
      simplified_billinginfoback_fields: this.getBillingInfoBackFields,
    })
  }
  handleConfirm(v: string): void {
    this.updateData(v)
    this?.debounceValidator?.()
  }

  handleExtraTips(e) {
    e?.stopPropagation()
    e?.preventDefault()
    if (this.config.extraTips.i18n) {
      this.showExtraTips = true
    }
  }

  handleOuterTip(e) {
    e?.stopPropagation()
    e?.preventDefault()
    if (this.config.extraTips?.outer_tip?.i18n) {
      this.showOuterTip = true
    }
  }
  setMessage(message: string) {
    this.message = message
  }
  handleClick(): void {
    const { config } = this
    const { type, component } = config
    if (
      config.type === 'block' ||
      !!config.disabled ||
      (type === TYPE.CELL && component === COMPONENT.INPUT)
    ) {
      return
    }
    if (type === TYPE.MODULE) {
      this.$emit('openModuleList')
      return
    }
    this.show = true
  }
  async validatorBlock(): Promise<boolean> {
    const isTelephoneValid = await this.$refs.phoneInputRef?.validateTelephone()

    return isTelephoneValid
  }
  async validatorByApi(
    account,
    name,
    value,
    taxType,
    template,
    required,
  ): Promise<boolean> {
    // not required and no input
    if (!required && !value) {
      return true
    }
    // 有税号格式 template，则在税号长度满足格式要求时，才调用检验接口
    if (template && value?.length !== template.length) {
      const { commonI18nTrans = {} } = this.qualConfig || {}
      this.setMessage(
        commonI18nTrans?.template_length_no_match || 'Incorrect tax length',
      )
      return false
    }

    const { data, code } = await account.validateTax({
      country: this.country,
      taxValue: {
        [name]: value || '',
      },
      taxType,
    })
    if (code === 0) {
      const result = data?.tax_validate_result?.filter(tax => tax.tax_key === name)[0]
      if (!result?.is_passed) {
        this.setMessage(result?.message)
        return false
      }
      this.setMessage('')
      return true
    }
  }
  async validatorByCustom(validators, value): Promise<boolean> {
    const { validate, message } = await validatorsFun(validators, value)
    if (!validate) {
      this.setMessage(message.toString())
      return false
    } else {
      this.setMessage('')
      this.flagPushTrack()
      return true
    }
  }
  async validatorCell(config, value): Promise<boolean> {
    const { name, validators, selfValidation, account, taxType, template, required } =
      config
    if (name === 'vat' && value && this.showRules?.[name]) {
      const { data, code } = await checkVatValid(value, this.country)
      const valid = code === 0 && data.valid
      if (!valid) {
        this.setMessage(data?.detail)
        return false
      } else {
        this.setMessage('')
        this.flagPushTrack()
        return true
      }
    }
    return selfValidation
      ? await this.validatorByApi(account, name, value, taxType, template, required)
      : await this.validatorByCustom(validators, value)
  }
  async validator(childInfo): Promise<boolean> {
    let { config, formData } = this
    if (childInfo?.childConfig) {
      config = childInfo.childConfig;
    }
    const { type, name, hidden, field } = config
    if (hidden) {
      this.setMessage('')
      return true
    }
    const value =
      field === FIELD.TAX_VALUE
        ? formData?.[FIELD.TAX_VALUE]?.[name]
        : formData?.[name]
    if (
      type === 'block' &&
      config.component === COMPONENT.PHONE_INPUT_COMPONENT
    ) {
      return await this.validatorBlock()
    }
    if (type === TYPE.CELL) {
      return await this.validatorCell(config, value)
    }
    this.flagPushTrack()
    return true
  }
  onIptValueChange(e: any) {
    const preVal = e?.target?.value?.trim() || ''
    let resultVal = preVal
    const taxItemTemplate = this.config.template
    // 针对税号，连续两个横杠 -- ，blur 时 replace成一个
    if (this.config.field === FIELD.TAX_VALUE) {
      resultVal = resultVal.replace(/-+/g, '-')
    }
    // 有模版的情况
    if (preVal.length && taxItemTemplate) {
      // 过滤掉模版填充的元素集合  template: **-*-***，其中 - 是自动填充的元素
      const replaceWords = taxItemTemplate?.match(/[^*]/g) || []
      const filteredVal = preVal
        .split('')
        .filter(v => !replaceWords.includes(v))
        .join('')
      let curReplaceValNum = 0
      resultVal = taxItemTemplate
        .split('')
        .map((val: string, index: number) => {
          let targetIndexVal = filteredVal[index - curReplaceValNum]
          if (val !== '*') {
            curReplaceValNum++
            targetIndexVal = filteredVal[index - curReplaceValNum]
            if (!targetIndexVal) {
              return undefined
            }
          }
          return val === '*' ? targetIndexVal : val
        })
        .filter((v: string) => v)
        .join('')
    }
    this.updateData(resultVal)
    this.debounceValidator()
  }

  onPhoneInputChange(phone, phoneCountry) {
    if (!phone) {
      return
    }
    this.updateData({
      phonenumber: phone,
      phonenumber_country: phoneCountry,
    })
  }

  async updateData(val: string) {
    let data = {}
    if (!this.config?.name) {
      return
    }
    if (this?.config?.field === FIELD.TAX_VALUE) {
      data[FIELD.TAX_VALUE] = {
        ...(this.formData?.[FIELD.TAX_VALUE] || {}),
        [this.config?.name]: val,
      }
    } else {
      data[this.config?.name] = val
    }

    // 回填不清空
    if (
      this?.config?.name === 'county' &&
      this.formData.county &&
      this.formData.county !== -1
    ) {
      data.city = -1
      data.address_detail = ''
      data.post_code = ''
    } else if (
      this?.config?.name === 'state' &&
      this.formData.state &&
      this.formData.state !== -1
    ) {
      data.city = -1
      data.county = -1
      data.address_detail = ''
      data.post_code = ''
    } else if (this?.config?.name === 'tax_type') {
      data.tax_value = {}
    }

    this.$emit('updateValue', data)
    if (this.config?.name === 'tax_type') {
      this.$emit('updateCellDetail', {
        field: FIELD.TAX_VALUE,
        selectTaxType: val,
        formIndex: this.$route.query?.formIndex
      })
    } else if (['state', 'county'].includes(this.config?.name)) {
      this.$emit('updateCellDetail', { name: this.config?.name, value: val, formIndex: this.$route.query?.formIndex })
    }
  }
}
